export function canonicalize(obj) {
    if (typeof obj === 'string') {
        return obj;
    }
    let buffer = '';
    serialize(obj);
    return buffer.replace(/\//g, '\\/');
    function serialize(object) {
        if (object === null || typeof object !== 'object' || object.toJSON != null) {
            buffer += JSON.stringify(object);
        }
        else if (Array.isArray(object)) {
            buffer += '[';
            let next = false;
            object.forEach((element) => {
                if (next) {
                    buffer += ',';
                }
                next = true;
                serialize(element);
            });
            buffer += ']';
        }
        else {
            buffer += '{';
            const vKeys = Object.keys(object)
                .filter((key) => object[key] !== undefined && object[key] !== null)
                .sort();
            vKeys.forEach((property, index) => addProp(object, property, index));
            buffer += '}';
        }
    }
    function addProp(object, property, index) {
        if (index > 0) {
            buffer += ',';
        }
        buffer += JSON.stringify(property);
        buffer += ':';
        serialize(object[property]);
    }
}
//# sourceMappingURL=canonicalize.js.map